import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { INotification, serverNotificationType } from '@/api/notifications/types';
import { useMarkNotificationAsRead } from '@/api/notifications/use-mark-notification-as-read';
import CloseBtn from '@/assets/svg/ui-elements/close.svg';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { PagePaths } from '@/routes/page-paths';
import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';

export type NotificationModalProps = {
  data: INotification;
};

export const NotificationModal = () => {
  const { open, handleClose, props } = useGlobalModal('NOTIFICATION_MODAL');
  const navigate = useNavigate();

  const isNewOffer = props?.data.type === serverNotificationType.FOLLOWED_COMPANY_NEW_OFFER;
  const hasOfferLink =
    isNewOffer && props?.data.metadata?.companyId && props?.data.metadata?.offerId;

  const { mutate: readNotification, isPending } = useMarkNotificationAsRead({
    onSuccess: () => {
      handleClose();
      if (hasOfferLink) {
        navigate(
          PagePaths.dealsOfferView
            .replace(':companyId', props!.data.metadata.companyId!)
            .replace(':offerId', props!.data.metadata.offerId!),
        );
      }
    },
  });

  const markAsRead = () => {
    readNotification(props?.data.id as string);
  };

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      sx={{ background: '#222833', maxWidth: 380, p: '24px 10px 16px' }}
    >
      <>
        <Box p="0px 14px" mb="55px">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            gap="12px"
            mb="10px"
          >
            <Typography
              fontSize={20}
              fontWeight={700}
              flex={1}
              minWidth={0}
              sx={{ wordBreak: 'break-word' }}
            >
              {props?.data.title}
            </Typography>
            <CustomButton
              onClick={handleClose}
              sx={{
                background: '#FFFFFF29',
                padding: 0,
                borderRadius: '300px',
                minWidth: '24px',
                height: '24px',
                flexShrink: 0,
              }}
            >
              <CloseBtn width={20} height={20} />
            </CustomButton>
          </Stack>
          <Typography variant="body2" mb="11px">
            {props?.data.message}
          </Typography>
          <Typography variant="body3" fontWeight="medium" sx={{ opacity: 0.4 }}>
            {props?.data?.createdAt ? moment(props.data.createdAt).format('DD.MM.YYYY') : ''}
          </Typography>
        </Box>
        <CustomButton
          onClick={markAsRead}
          disabled={isPending}
          fullWidth
          variant="contained"
          sx={{ fontSize: 14, fontWeight: 500, borderRadius: '8px', height: 48 }}
        >
          {isPending ? (
            <CircularProgress color="success" size={16} />
          ) : hasOfferLink ? (
            'View Offer'
          ) : (
            'Mark as Read'
          )}
        </CustomButton>
      </>
    </CustomModal>
  );
};
